// src/pages/PostDetail.js
import React from "react";
import { useParams, Link } from "react-router-dom";
import postsData from "../data/posts.json";
import styles from "./PostDetail.module.css";

function PostDetail() {
  const { id } = useParams();
  const post = postsData.find((p) => p.id === id);

  if (!post) {
    return (
      <div className={styles.container}>
        <h2>Post Not Found</h2>
        <p>The post you're looking for doesn't exist.</p>
        <Link to="/posts" className={styles.backLink}>
          Back to Posts
        </Link>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Link to="/posts" className={styles.backLink}>
        &larr; Back to Posts
      </Link>
      <h1>{post.title}</h1>
      <h2>{post.subtitle}</h2>
      <img src={post.image} alt={post.title} className={styles.postImage} />
      <p className={styles.date}>{new Date(post.date).toLocaleDateString()}</p>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: post.content }}
      />
    </div>
  );
}

export default PostDetail;